// The practice-game categories, shared by the Game Zone, the next-step card and homework help.
// `code` is the skill code the server uses to pick questions.
export const GAME_GRADES = ["P3", "P4", "P5", "P6"];

export const GAME_GROUPS = [
  { key: "words", title: "Words and sentences", bg: "#E6F8F5" },
  { key: "story", title: "Story writing", bg: "#EFE9FF" },
];

export const GAME_SKILLS = [
  { code: "grammar", label: "Grammar", group: "words", blurb: "Fix and join sentences" },
  { code: "vocabulary", label: "Vocabulary", group: "words", blurb: "Find the best word" },
  { code: "spelling", label: "Spelling", group: "words", blurb: "Spot the spelling slip" },
  { code: "sequencing", label: "Story order", group: "story", blurb: "Put events in order" },
  { code: "transitions", label: "Linking words", group: "story", blurb: "First, then, because, but" },
  { code: "paragraphing", label: "Paragraphs", group: "story", blurb: "When to start a new one" },
  { code: "openings", label: "Story openings", group: "story", blurb: "Start with a bang" },
  { code: "details", label: "Vivid details", group: "story", blurb: "Show feelings, don't just say" },
  { code: "endings", label: "Story endings", group: "story", blurb: "Finish with feeling" },
  { code: "ontopic", label: "Stay on topic", group: "story", blurb: "Titles and ideas that fit" },
];

export const skillLabel = (code) => (GAME_SKILLS.find((s) => s.code === code) || {}).label || code;
export const isGameSkill = (code) => GAME_SKILLS.some((s) => s.code === code);

// Which game goes with a report score (when it has no parts) ...
export const SKILL_BY_SCORE = { GM: "grammar", VC: "vocabulary", SP: "spelling", ST: "transitions", CT: "details", CR: "ontopic" };
// ... and with a part inside Structure & Flow, Development or Relevance & Logic (keyed by the part's lower-case title).
export const SKILL_BY_PART = {
  organisation: "sequencing",
  logic: "sequencing",
  transitions: "transitions",
  paragraphing: "paragraphing",
  "title relevance": "ontopic",
  relevance: "ontopic",
  intro: "openings",
  body: "details",
  conclusion: "endings",
};
